import { render, staticRenderFns } from "./SplitForm.vue?vue&type=template&id=b357b3ba"
var script = {}
import style0 from "./SplitForm.vue?vue&type=style&index=0&id=b357b3ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports